import React from "react";
import landscape0 from "../../assets/images/landscape0.jpeg";
import landscape1 from "../../assets/images/landscape1.jpg";
import landscape2 from "../../assets/images/landscape2.jpg";
import landscape3 from "../../assets/images/landscape3.jpeg";
import landscape4 from "../../assets/images/landscape4.jpg";
import landscape5 from "../../assets/images/landscape5.jpg";
import landscape6 from "../../assets/images/landscape6.jpg";
import landscape7 from "../../assets/images/landscape7.jpg";
import landscape9 from "../../assets/images/landscape9.jpg";
import landscape10 from "../../assets/images/landscape10.jpg";
import landscape11 from "../../assets/images/landscape11.jpg";
import landscape12 from "../../assets/images/landscape12.jpeg";
import landscape13 from "../../assets/images/landscape13.jpeg";
import landscape14 from "../../assets/images/landscape14.jpeg";
import landscape15 from "../../assets/images/landscape15.jpeg";
import landscape16 from "../../assets/images/landscape16.jpeg";
import landscape17 from "../../assets/images/landscape17.jpeg";
import landscape18 from "../../assets/images/landscape18.jpeg";
import landscape19 from "../../assets/images/landscape19.JPG";
import landscape20 from "../../assets/images/landscape20.jpeg";
import landscape21 from "../../assets/images/landscape21.JPG";
import landscape22 from "../../assets/images/landscape22.JPG";
import landscape23 from "../../assets/images/landscape23.JPG";
import landscape24 from "../../assets/images/landscape24.JPG";
import landscape25 from "../../assets/images/landscape25.JPG";
import landscape26 from "../../assets/images/landscape26.JPG";
import landscape27 from "../../assets/images/landscape27.jpeg";
import landscape29 from "../../assets/images/landscape29.JPG";
import landscape30 from "../../assets/images/landscape30.JPG";
import landscape31 from "../../assets/images/landscape31.jpeg";
import landscape32 from "../../assets/images/landscape32.jpeg";
import landscape33 from "../../assets/images/landscape33.jpeg";
import landscape34 from "../../assets/images/landscape34.jpeg";
import landscape35 from "../../assets/images/landscape35.jpeg";
import landscape36 from "../../assets/images/landscape36.jpeg";
import landscape37 from "../../assets/images/landscape37.jpeg";
import portrait0 from "../../assets/images/portrait0.png";
import portrait2 from "../../assets/images/portrait2.jpg";
import portrait3 from "../../assets/images/portrait3.jpeg";
import portrait4 from "../../assets/images/portrait4.JPG";
import portrait5 from "../../assets/images/portrait5.JPG";
import portrait6 from "../../assets/images/portrait6.JPG";
import portrait7 from "../../assets/images/portrait7.jpeg";
import portrait8 from "../../assets/images/portrait8.JPG";
import portrait9 from "../../assets/images/portrait9.JPG";
import portrait10 from "../../assets/images/portrait10.jpeg";
import portrait11 from "../../assets/images/portrait11.jpeg";
import portrait12 from "../../assets/images/portrait12.jpeg";

import "./portfolio.page.styles.scss";
const Portfolio = () => {
  return (
    <div className="portfolio-container" id="portfolio">
      <h1 className="portfolio-title box-shadow">Portfolio</h1>

      <div className="portfolio-picture-container">
        <div className="landscape grow">
          <img src={landscape13} alt="Portfolio pic" />
        </div>
        <div className="portrait grow">
          <img src={portrait12} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape1} alt="Portfolio pic" />
        </div>
        <div className="portrait grow">
          <img src={portrait0} alt="Portfolio pic" />
        </div>
        <div className="normal grow">
          <img src={landscape2} alt="Portfolio pic" />
        </div>
        <div className="normal grow">
          <img src={landscape3} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape4} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape5} alt="Portfolio pic" />
        </div>
        <div className="portrait grow">
          <img src={portrait11} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape6} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape7} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape36} alt="Portfolio pic" />
        </div>
        <div className="portrait grow">
          <img src={portrait9} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape9} alt="Portfolio pic" />
        </div>
        <div className="portrait grow">
          <img src={portrait10} alt="Portfolio pic" />
        </div>
        <div className="normal grow">
          <img src={landscape10} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape11} alt="Portfolio pic" />
        </div>
        <div className="portrait grow">
          <img src={portrait7} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape12} alt="Portfolio pic" />
        </div>

        <div className="portrait grow">
          <img src={portrait8} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape15} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape16} alt="Portfolio pic" />
        </div>
        <div className="normal grow">
          <img src={landscape29} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape17} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape18} alt="Portfolio pic" />
        </div>
        <div className="portrait grow">
          <img src={portrait6} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape19} alt="Portfolio pic" />
        </div>
        <div className="normal grow">
          <img src={landscape20} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape21} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape22} alt="Portfolio pic" />
        </div>

        <div className="portrait grow">
          <img src={portrait5} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape24} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape25} alt="Portfolio pic" />
        </div>
        <div className="normal grow">
          <img src={landscape26} alt="Portfolio pic" />
        </div>
        <div className="portrait grow">
          <img src={portrait4} alt="Portfolio pic" />
        </div>
        <div className="normal grow">
          <img src={landscape27} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape14} alt="Portfolio pic" />
        </div>
        <div className="portrait grow">
          <img src={portrait3} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape30} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape31} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape32} alt="Portfolio pic" />
        </div>
        <div className="portrait grow">
          <img src={portrait2} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape33} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape34} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape35} alt="Portfolio pic" />
        </div>
        <div className="normal grow">
          <img src={landscape23} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape36} alt="Portfolio pic" />
        </div>
        <div className="landscape grow">
          <img src={landscape37} alt="Portfolio pic" />
        </div>
        {/* <div className="normal grow">
          <img src={landscape28} alt="Portfolio pic" />
        </div> */}
        <div className="landscape grow">
          <img src={landscape0} alt="Portfolio pic" />
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
